import React, { useMemo } from "react";
import styled from "styled-components";

import { scaleByWidth } from "@examspark/common-util";
import { Stem } from "@examspark/types";

import { useDrag } from "../../common/drag/useDrag";
import Mark from "../../common/Mark";

const Styled = styled.div`
  border: solid 1px transparent;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s;

  &:hover {
    border-color: #aaa;
    background-color: rgba(255, 255, 255, 0.5);
  }
  img {
    max-width: none !important;
  }
`;

interface Props {
  x?: number;
  y?: number;
  /**
   * Value to reduce tokens by a certain percent to match any scaling of the
   * sibling `<ImageMap />` element. */
  scale?: number;
  cloneOnDrag?: boolean;
  data: Stem.Token;
  instanceId?: string;
  mark?: "correct" | "incorrect";
  onInit?: (ref: any) => void;
  onDragStart: () => void;
  onDragEnd: (instance: any, instanceId: any) => void;
}

const Draggable: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const drag: any = useDrag({
    item: {
      type: "token",
      id: props.data.id,
    },
    cloneOnDrag: props.cloneOnDrag,
    draggableId: props.data.id,
    instanceId: props?.instanceId || undefined,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
  });

  const scale = useMemo(() => {
    let size = scaleByWidth(
      props.data.metadata.width,
      props.data.metadata.height,
      props.data.metadata.width,
    );

    // resolution-scale
    if (props.data.metadata.scale) {
      switch (props.data.metadata.scale) {
        case "@2x":
          size = scaleByWidth(
            props.data.metadata.width,
            props.data.metadata.height,
            props.data.metadata.width / 2,
          );
      }
    }

    // <ImageMap> scale
    if (props.scale) {
      size = scaleByWidth(size.width, size.height, size.width * props.scale);
    }

    // console.log("drag scale", size);

    return size;
  }, [props.data.metadata, props.scale]);

  /** adjust placement for token size and border such that the object is
   * centered */
  const styles: any = {};
  if (props.x !== undefined) {
    styles.left = props.x - scale.width / 2 - 1 + "px";
  }
  if (props.y !== undefined) {
    styles.top = props.y - scale.height / 2 - 1 + "px";
  }

  return (
    <Styled ref={drag} style={styles} className="item-player-img-token">
      <div className="item-player-img-token-wrapper">
        {props.mark && <Mark type={props.mark} />}
        <img
          alt={"Draggable Token"}
          width={scale.width}
          // height={scale.height}
          src={props.data.src}
          onLoad={() => {
            props.onInit?.(drag);
          }}
        />
      </div>
    </Styled>
  );
};

export default Draggable;
